import React from 'react';
import '../styles/App.css'; 

const WhyChoose = () => {
  const benefits = [
    {
      icon: "📍",
      title: "Convenient Location",
      description: "Strategic location in Lilongwe with easy access to business and leisure destinations"
    },
    {
      icon: "💰",
      title: "Affordable Comfort",
      description: "Quality accommodation at competitive rates without compromising on comfort"
    },
    {
      icon: "👨‍💼",
      title: "Professional Staff",
      description: "Friendly and professional team dedicated to making your stay memorable"
    },
    {
      icon: "🏢",
      title: "Versatile Facilities",
      description: "Suitable for both business travelers and leisure stays with conference facilities"
    },
    {
      icon: "🔒",
      title: "Secure Environment",
      description: "Safe and peaceful environment with 24/7 security monitoring"
    },
    {
      icon: "🛏️",
      title: "Quality Accommodation",
      description: "14 well-maintained rooms designed for comfort and relaxation"
    }
  ];

  return (
    <section className="why-choose-section">
      <div className="container">
        <h2 className="section-title">Why Choose Talali Lodge</h2>
        
        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit-card">
              <div className="benefit-icon">{benefit.icon}</div>
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;